import React from "react";

import moment from "moment";
import GlobalApi from "./../../Global";
import refresh_token from "./../../Global/refresh_token";
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Container,
  Button,
  TableHead,
  Tabs,
  Tab,
  Grid,
} from "@material-ui/core";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import swal from "@sweetalert/with-react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Colors from "./../../Global/colors";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import CheckIcon from "@material-ui/icons/CheckCircle";
import DarkButton from "./../../Global/DarkButton";
import Spinner from "./../../Global/Spinner";
import Inspection from "./../../Assets/Inspection.png";
import Restricted from "./../../Assets/no_feature.png";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const useStyles = makeStyles((theme) => ({
  root: {},
  tableRow: {
    hover: {
      backgroundColor: "none",
    },
  },
  tableBorder: {
    // borderWidth: 0,
    borderWidth: 1,
    borderColor: "#0f548c",
    borderStyle: "solid",
  },
  tableBorderRight: {
    borderWidth: 0,
    // borderRightWidth: 1,
    color: "#222",
    borderRadius: 0,
    borderColor: "#f0f2f5",
    borderStyle: "solid",
    //textTransform: "uppercase",
    padding: 10,
    //fontSize:17,
    fontFamily: "ProductSans",
    // minHeight: 30,
  },
}));

const AntTabs = withStyles({
  root: {
    backgroundColor: "#ffffff",
    color: "#222",
  },
  indicator: {
    backgroundColor:'#1a73e8'
    // display:'none'
  },
})(Tabs);


// const color1=`rgb(85,206,199)`;
// const color2=`rgb(22,103,219)`;
const color1 = `rgb(84,239,208)`;
const color2 = `rgb(84,239,208)`;

const ID1 = "b89044a0-5314-4eda-816d-2969083ad4f4"  //small
const ID2 = "09b7b809-3f45-4439-9836-ba91b160174d" //enterprise
const ID3 = "85232b2e-3301-4a8e-bd6e-d1f00c7dd1b5" //free

export default function AddPackagePlan() {
  let {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  const history = useHistory();
  const [pricing, setPricing] = React.useState({});
  const [packageId, setPackageId] = React.useState({});
  const classes = useStyles();
  const [currentPackage, setCurrentPackage] = React.useState({});
  const [packageDetails, setPackageDetails] = React.useState(null);
  const [organization, setOrganization] = React.useState({});
  const [currency, setCurrency] = React.useState("doller");
  const [value, setValue] = React.useState(1);
  const [expired, setExpired] = React.useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  

  function getPricing(currentCurrency) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      payment_type: currentCurrency,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/PricingModule/get_all_pricing_modules?" , {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          let grouped_res = await _.groupBy(response.data, (v) => v.title);
          let obj_package = {};
          let final_grouped_res = {};
          await Object.keys(grouped_res).map(async (key, mainI) => {
            let obj = await _.groupBy(
              grouped_res[key][0]?.PricingFeatures,
              (v) => v.title
            );
            final_grouped_res[key] = obj;
            if (mainI === Object.keys(grouped_res).length - 1) {
              await Object.keys(final_grouped_res).map(async (key1) => {
                await Object.keys(final_grouped_res[key1]).map(async (key2) => {
                  let obj = await _.groupBy(
                    final_grouped_res[key1][key2],
                    (v) => v?.Package?.id
                  );
                  final_grouped_res[key1][key2] = obj;
                  obj_package = obj;
                });
              });
              setPricing(final_grouped_res);

              let package_ids = {};
              await Object.keys(obj_package).map((key) => {
                package_ids[key] = obj_package[key][0].Package.id;
              });
              setPackageId(package_ids);

              let package_details = {};
              await Object.keys(obj_package).map((key) => {
                package_details[key] = obj_package[key][0].Package;
              });
              await setCurrency(currentCurrency);
              setPackageDetails(package_details);
            }
          });
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPricing(currentCurrency);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }
  function getPackageDetail() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id: data?.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Package/get_package_history?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          // console.log(response.data);
          if (
            new Date().getTime() > new Date(response.data.expiry_date).getTime()
          ) {
            setExpired(true);
          }
          setCurrentPackage(response.data);
          if(getMonthDifference(new Date(response?.data?.createdAt), new Date(response?.data?.expiry_date)) < 12 ){
            setValue(0)
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPackageDetail();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

    //find difference of months between two dates
    function getMonthDifference(startDate, endDate) {
      return (
        endDate.getMonth() -
        startDate.getMonth() +
        12 * (endDate.getFullYear() - startDate.getFullYear())
      );
    }
  
    const Months = getMonthDifference(new Date(currentPackage?.createdAt), new Date(currentPackage?.expiry_date))

  function getOrganization() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id: data?.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Organization/get_organization?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          setOrganization(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getOrganization();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  const changeCurrency = (e) => {
    getPricing(e);
  };

  React.useEffect(() => {
    getPackageDetail();
    getOrganization();
  }, []);

  React.useEffect(() => {
    getPricing(currency);
  }, []);

  function handleSubmit(type) {
    console.log("hehehe", type);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;

    fetch(GlobalApi + "/Package/create_package_history", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        package_id: type,
        organization_id: data.organization_id,
        expiry_date: moment().add(15, "days"),
        status: "active",
      }),
    })
      .then(async (response) => {
        await fetch(GlobalApi + "/Organization/edit_organization", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            organization_id: data.organization_id,
            free_trial: "Availed",
          }),
        });
        swal(t("Success"), t("Package Updated!"), "success");
        setCurrentPackage(response.data);

        window.location.reload();
        history.push("/");
      })
      .catch((err) => console.log(err));
  }
  const daysTillPackageExpires = (packageExpiry) => {

    const today = new Date();
    const expiryDate = new Date(packageExpiry);
    const diffTime = Math.abs(expiryDate - today);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;

};

  const handleRedirect = (path,isPackageRenew,expiryDate) => {
    console.log("Renew",isPackageRenew)
      history.push( {pathname: path,
      state: {
        isRenew: isPackageRenew,
      },});
    };


  // console.log(currentPackage?.package_id ===
  //   packageId[currency == 'doller' ? ID1 : "dfb5611e-b190-43c9-aed7-aa67e6cf60d9"] ||
  // currentPackage?.package_id === packageId[currency == 'doller' ? ID2 : "62ed88e3-38f1-4ada-8ccf-5d43f83d8000"])
  if (pricing === null || packageDetails === null) {
    return (
      <div>
        <Spinner />
      </div>
    );
  } else {
    //  console.log(pricing, "PACKAGE ID");
    // let free_no = pricing["Inspection"] && pricing["Inspection"]["Inspection Limit"] && pricing["Inspection"]["Inspection Limit"][currency == "doller" ? ID3 : "baeb2aee-3c5f-49e4-bdf5-2dd0dec191ba"][0]?.value;
    // let mid_no =
    //   pricing["Inspection"] &&
    //   pricing["Inspection"]["Inspection Limit"] &&
    //   pricing["Inspection"]["Inspection Limit"][
    //     ID1
    //   ][0]?.value;
    // let enterprice_no =
    //   pricing["Inspection"] &&
    //   pricing["Inspection"]["Inspection Limit"] &&
    //   pricing["Inspection"]["Inspection Limit"][
    //     ID2
    //   ][0]?.value;

    // console.log(pricing);

    return <div className="" style={{ padding: "0px", display: "flex", flexDirection: "column", backgroundColor: Colors.globalColor9 }}>
        <div className="" style={{ padding: "20px", height: "100vh", textAlign: "left", overflowY: "scroll", backgroundColor: Colors.globalColor9 }}>
          <div style={{ overflow: "auto", padding: "0px", backgroundColor: "white", borderRadius: "10px", boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)" }}>
            {/* <Typography variant="h4" style={{ fontWeight: "500", color: Colors.buttonTextColor }}>Upgrade Package Plan</Typography> */}

            <Grid container alignItems="center" align="center" justify="center">
              <Grid item xs={3} />

              <Grid item xs={12} md={12}>
                <div style={{ borderBottom: "1px solid #dadada", width: "100%" }}>
                  <AntTabs value={value} style={{ color: Colors.buttonTextColor, bottomBorder: "1px solid #dadada", marginTop:'5px' }} textColor="primary" onChange={handleChange} aria-label="disabled tabs example" centered>
                    <Tab fullWidth label={t("Monthly")} className="templateTab" style={{ margin: "0",padding:'5px 10px', textTransform: "uppercase", fontSize:language =="ar" ? 18 : 14, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? "#1a73e8" : "black" }} />
                    <Tab fullWidth label={<div style={{display:'flex', flexDirection:'row',alignItems:'center', justifyContent:'center',position:"relative" }}><div>{t("Annually")}</div> &emsp; <div style={{padding:'8px',backgroundColor:"#1a73e8" , color:"white", borderRadius:'50px'}}><p style={{margin:'0px', fontSize:'10px', lineHeight:'9px'}}>25%</p><p style={{margin:'0px', fontSize:'9px',lineHeight:'10px'}}>off</p></div> </div>} className="templateTab" style={{ margin: "0px",padding:'5px 10px', textTransform: "uppercase", fontSize: language =="ar" ? 18 : 14, fontWeight: "bold",backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? "#1a73e8" : "black" }} />
                  </AntTabs>
                </div>
                <br />
                <div>
                  <p style={{ marginBottom: 5, fontSize: 14, fontWeight: "bold", marginTop: 7, display: "inline", color: Colors.globalColor8 }}>
                    {t("Select Currency")} :
                  </p>
                  &emsp;
                  <Select className="SelectBox" style={{ minWidth: 120, textAlign: "left" }} variant="outlined" size="small" value={currency} onChange={(e) => changeCurrency(e.target.value)}>
                    <MenuItem value={"doller"}>{t("Dollar")} $</MenuItem>
                    <MenuItem value={"pound"}>{t("Pounds")} £</MenuItem>
                  </Select>
                </div>
              </Grid>
              <Grid item xs={3} />
              <Grid item xs={12} style={{ margin: 20 }}>
                <Grid container spacing={3} justify="center">

                  <Grid item xs={12} md={4}>
                    <Paper style={{ padding: 30, borderRadius: 20, paddingTop: 30, paddingBottom: 30, height: "100%", border: "1px solid #dadada", backgroundColor: "white" } //variant="outlined"
                      }>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Typography variant="h5" style={{ fontWeight: "600", textTransform: "upperCase", color: Colors.globalColor8 }}>
                            {t("Small / Medium")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="p" style={{ color: Colors.buttonTextColor }}>
                            {t("Download the app, see how it works, fall in love with it and start using it regularly.")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} style={{ paddingBottom: "0px" }}>
                          <Typography variant="h2" style={{ fontWeight: "800", color: Colors.buttonTextColor }}>
                            {currency == "doller" ? "$" : "£"}
                            {value == 0 ? (currency == "doller" ? packageDetails[ID1]?.price_per_user : packageDetails[ID1]?.price_per_user_in_pound) : currency == "doller" ? packageDetails[ID1]?.yearly_price : packageDetails[ID1]?.yearly_price_in_pound}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: "0px" }}>
                          <Typography variant="p" style={{ color: Colors.buttonTextColor }}>
                            {t("Per User Per Month")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <hr />
                        </Grid>
                        {/* <Grid item xs={12}>
                        <Typography variant="p">All of free, plus:</Typography>
                      </Grid> */}
                        <Grid item xs={12}>
                          <Grid container align="center">
                            <Grid item>
                              <CheckIcon size={"small"} style={{ fontSize: 20, marginRight: 10, color: Colors.buttonTextColor }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="p" style={{ color: Colors.buttonTextColor }}>
                                {t("Unlimited inspections")}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container align="center">
                            <Grid item>
                              <CheckIcon size={"small"} style={{ fontSize: 20, marginRight: 10, color: Colors.buttonTextColor }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="p" style={{ color: Colors.buttonTextColor }}>
                                {t("User roles & permissions")}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container align="center">
                            <Grid item>
                              <CheckIcon size={"small"} style={{ fontSize: 20, marginRight: 10, color: Colors.buttonTextColor }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="p" style={{ color: Colors.buttonTextColor }}>
                                {t("On demand analytics")}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                       
                        <Grid item xs={12}>

                          <Button variant="contained" type="submit" className="addBtn" component="span" disabled={currentPackage?.package_id === packageId[ID1] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) && daysTillPackageExpires(currentPackage?.expiry_date) > 10} onClick={() => handleRedirect(("/update_package/" + (packageId[ID1] + "/" + (value == 0 ? "Monthly" : "Yearly")) + "/" + currency), (currentPackage?.package_id === packageId[ID1] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? true : false), currentPackage?.expiry_date)}>
                            {currentPackage?.package_id === packageId[ID1] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? t("Renew") : t("Purchase")}{" "}
                          </Button>


                          {/* <Button variant="contained" type="submit" className="addBtn" component="span" disabled={currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) && daysTillPackageExpires(currentPackage?.expiry_date) > 10}
                          onClick={() => handleRedirect( ("/update_package/" +
                                    (packageId[ID1] +
                                      "/" +
                                      (value == 0 ? "Monthly" : "Yearly")) +
                                    "/" +
                                    currency), (currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? true : false), currentPackage?.expiry_date)}>
                            {currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ?  t("Renew") : t("Purchase")}
                          </Button> */}
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Paper variant="outlined" style={{ padding: 30, borderRadius: 20, paddingTop: 30, paddingBottom: 30, height: "100%", backgroundColor: "#4faff9" }}>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Typography variant="h5" style={{ fontWeight: "600", color: "white", textTransform: "upperCase" }}>
                            {t("Enterprise")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="p" style={{ color: "white" }}>
                            {t("Talk to our consultant for the enterprise version and we will give you one-on-one orientation as well as any further help that you need.")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} style={{ paddingBottom: "0px" }}>
                          <Typography variant="h2" style={{ fontWeight: "800", color: "white", marginBottom: "0" }}>
                            {currency == "doller" ? "$" : "£"}
                            {value == 0 ? (currency == "doller" ? packageDetails[ID2]?.price_per_user : packageDetails[ID2]?.price_per_user_in_pound) : currency == "doller" ? packageDetails[ID2]?.yearly_price : packageDetails[ID2]?.yearly_price_in_pound}
                            {/* {value == 0
                              ? packageDetails[
                                  ID2
                                ]?.price_per_user
                              : packageDetails[
                                  ID2
                                ]?.yearly_price} */}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: "0px" }}>
                          <Typography variant="p" style={{ color: "white" }}>
                            {t("Per User Per Month")}{" "}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <hr />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="p" style={{ color: "white" }}>
                            {t("All of premium, plus:")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container align="center">
                            <Grid item>
                              <CheckIcon size={"small"} style={{ fontSize: 20, marginRight: 10, color: "white" }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="p" style={{ color: "white" }}>
                                {t("Dedicated account management")}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container align="center">
                            <Grid item>
                              <CheckIcon size={"small"} style={{ fontSize: 20, marginRight: 10, color: "white" }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="p" style={{ color: "white" }}>
                                {t("Complex user management")}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container align="center">
                            <Grid item>
                              <CheckIcon size={"small"} style={{ fontSize: 20, marginRight: 10, color: "white" }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="p" style={{ color: "white" }}>
                                {t("Enhanced support response time")}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                        <Button variant="contained" type="submit" className="addBtn" component="span" disabled={currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) && daysTillPackageExpires(currentPackage?.expiry_date) > 10}
                          onClick={() => handleRedirect( ("/update_package/" +
                                    (packageId[ID2] +
                                      "/" +
                                      (value == 0 ? "Monthly" : "Yearly")) +
                                    "/" +
                                    currency), (currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? true : false), currentPackage?.expiry_date)}>
                            {currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? t("Renew") : t("Purchase")}
                          </Button>

                        {/* <Button variant="contained" type="submit" className="addBtn" component="span" disabled={currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) && daysTillPackageExpires(currentPackage?.expiry_date) > 10}
                          onClick={() => handleRedirect( ("/update_package/" +
                                    (packageId[ID2] +
                                      "/" +
                                      (value == 0 ? "Monthly" : "Yearly")) +
                                    "/" +
                                    currency), (currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? true : false), currentPackage?.expiry_date)}>
                            {currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? t("Renew") : t("Purchase")}
                          </Button> */}

                          {/* <Button variant="contained" type="submit" className="addBtn" component="span"
                            onClick={() => history.push("/update_package/" + (packageId[ID2] + "/" + (value == 0 ? "Monthly" : "Yearly")) + "/" + currency)} disabled={expired == false ? currentPackage?.package_id === packageId[ID2] : false}>
                            {currentPackage?.package_id === packageId[ID2] ? t("Renew") : t("Purchase")}
                          </Button> */}
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <div style={{ marginTop: 10, padding: "20px", width: "100%" }}>
              <Table style={{minWidth:'900px'}}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                      <Typography variant="h6" style={{ color: Colors.globalColor8, fontWeight: "bold" }}>
                        {t("COMPARE PLANS & FEATURES")}
                      </Typography>
                    </TableCell>
                    {/* <TableCell
                    className={classes.tableBorderRight}
                    style={{
                      textAlign: "center",
                      // backgroundColor: "#2196f3",
                      color: Colors.buttonTextColor,
                    }}
                  >
                    <Typography variant="h6">Free</Typography>
                  </TableCell> */}
                    <TableCell style={{ padding: 0 }}>
                      <div style={{ textAlign: "center", color: Colors.buttonTextColor, border: "1px solid #dadada", backgroundColor: "white", padding: "15px 20px", borderBottom: "0px", height: "100%", borderRadius: "20px 20px 0 0" }}>
                        <Typography variant="h6">{t("Small / Medium")}</Typography>
                      </div>
                    </TableCell>
                    <TableCell style={{ padding: 0 }}>
                      <div style={{ textAlign: "center",backgroundColor:Colors.globalColor8, color: "white", border: "1px solid #dadada", padding: "15px 20px", borderBottom: "0px", height: "100%", borderRadius: "20px 20px 0 0" }}>
                        <Typography variant="h6">{t("Enterprise")}</Typography>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{ border: "1px solid #dadada" }}>
                  {Object.keys(pricing).map((key, i) => {
                    return [<TableRow style={{ color: "black", backgroundColor: Colors.globalColor9 }}>
                        <TableCell style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                          <Typography variant="h6" style={{ color: Colors.buttonTextColor }}>
                            {key}
                          </Typography>
                        </TableCell>
                        {/* <TableCell
                        className={classes.tableBorderRight}
                        style={{
                          textAlign: "center",
                          // backgroundColor: "#2196f3",
                        }}
                      /> */}
                        <TableCell style={{ textAlign: "center", paddingTop: "10px", paddingBottom: "10px" }} />
                        <TableCell style={{ textAlign: "center", paddingTop: "10px", paddingBottom: "10px" }
                            // backgroundColor: "#2196f3",
                          } />
                      </TableRow>, Object.keys(pricing[key]).map(
                        (valKey, valI) => {
                          let cond = `${key}-${valKey}`;
                          // let free_data =
                          //   pricing[key][valKey][
                          //     currency == "doller"
                          //       ? ID3
                          //       : "baeb2aee-3c5f-49e4-bdf5-2dd0dec191ba"
                          //   ][0];

                          let small_data =
                            pricing[key][valKey] &&
                            pricing[key][valKey][ID1][0];
                          let enterprise_data = pricing[key][valKey][ID2][0];

                            console.log("enterprise_data", enterprise_data)
                          return (
                            <TableRow
                              key={cond}
                              style={{
                                backgroundColor:
                                  valI % 2 == 0 ? "#f9fafc" : "white",
                              }}
                            >
                              <TableCell
                                style={{
                                  color: "black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                  height: "45px",
                                }}
                              >
                                <Typography> {valKey} </Typography>
                              </TableCell>
                              {/* <TableCell
                            className={classes.tableBorderRight}
                            style={{
                              textAlign: "center",
                              // backgroundColor: "#2196f3",
                            }}
                          >
                            {free_data.value_type === "yesnolimited" ? (
                              free_data.value === "yes" ? (
                                <CheckCircleIcon style={{ color: "green" }} />
                              ) : (
                                <NotInterestedIcon />
                              )
                            ) : (
                              `${free_data.value} ${free_data.label}`
                            )}
                          </TableCell> */}
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                  height: "45px",
                                }}
                              >
                                {small_data?.value_type ===
                                "yesnolimited" ? (
                                  small_data?.value === "yes" ? (
                                    // <CheckCircleIcon
                                    //   style={{
                                    //     color: "green",
                                    //     padding: 0,
                                    //     margin: 0,
                                    //     fontSize: 20
                                    //   }}
                                    // />

                                    <img src={Inspection} width={25} />
                                  ) : (
                                    <img src={Restricted} width={20} />
                                  )
                                ) : (
                                  <Typography>
                                    {" "}
                                    {`${small_data.value} ${
                                      small_data?.label
                                    }`}
                                  </Typography>
                                )}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                  height: "45px",
                                  // backgroundColor: "#2196f3",
                                }}
                              >
                                {enterprise_data?.value_type ===
                                "yesnolimited" ? (
                                  enterprise_data?.value === "yes" ? (
                                    // <CheckCircleIcon
                                    //   style={{
                                    //     color: "green",
                                    //     padding: 0,
                                    //     margin: 0,fontSize: 20
                                    //   }}
                                    // />
                                    <img src={Inspection} width={25} />
                                  ) : (
                                    <img src={Restricted} width={20} />
                                  )
                                ) : (
                                  <Typography>{`${enterprise_data?.value} ${
                                    enterprise_data?.label
                                  }`}</Typography>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )];
                  })}

                  <TableRow>
                    <TableCell />
                    {/* <TableCell
                    className={classes.tableBorderRight}
                    style={{
                      textAlign: "center",
                      // backgroundColor: "#2196f3",
                      color: Colors.buttonTextColor,
                    }}
                  >
                    <Typography variant="h6">Free</Typography>
                    <DarkButton
                      variant="outlined"
                      // size="large"
                      onClick={() =>
                        history.push(
                          "/update_package/" +
                            (packageId[currency == 'doller' ? ID3 : "baeb2aee-3c5f-49e4-bdf5-2dd0dec191ba"] +
                              "/" +
                              (value == 0 ? "Monthly" : "Yearly"))
                        )
                      }
                      disabled={
                        currentPackage?.package_id === packageId[currency == 'doller' ? ID3 : "baeb2aee-3c5f-49e4-bdf5-2dd0dec191ba"]
                      }
                    >
                      Purchase
                    </DarkButton>
                  </TableCell> */}
                    <TableCell style={{ textAlign: "center", color: Colors.buttonTextColor }}>
                      <Typography variant="h6">{t("Small / Medium")}</Typography>
                    

                      <Button variant="contained" type="submit" className="addBtn" component="span" disabled={currentPackage?.package_id === packageId[ID1] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) && daysTillPackageExpires(currentPackage?.expiry_date) > 10} 
                      onClick={() => handleRedirect( ("/update_package/" +
                      (packageId[ID1] +
                        "/" +
                        (value == 0 ? "Monthly" : "Yearly")) +
                      "/" +
                      currency), (currentPackage?.package_id ===
                        packageId[ID1] &&
                      ((Months < 12 && value == 0) ||
                        (Months >= 12 && value == 1))
                        ? true
                        : false), currentPackage?.expiry_date)}>
                        {currentPackage?.package_id === packageId[ID1] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? t("Renew") : t("Purchase")}{" "}
                      </Button>

                      {/* <Button variant="contained" type="submit" className="addBtn" component="span" disabled={currentPackage?.package_id === packageId[ID1] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) && daysTillPackageExpires(currentPackage?.expiry_date) > 10} 
                      onClick={() => handleRedirect( ("/update_package/" +
                      (packageId[ID1] +
                        "/" +
                        (value == 0 ? "Monthly" : "Yearly")) +
                      "/" +
                      currency), (currentPackage?.package_id ===
                        packageId[ID1] &&
                      ((Months < 12 && value == 0) ||
                        (Months >= 12 && value == 1))
                        ? true
                        : false), currentPackage?.expiry_date)}>
                        {currentPackage?.package_id === packageId[ID1] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? t("Renew") : t("Purchase")}{" "}
                      </Button> */}
                    </TableCell>
                    <TableCell style={{ textAlign: "center", color: Colors.buttonTextColor }
                        // backgroundColor: "#2196f3",
                      }>
                      <Typography variant="h6">{t("Enterprise")}</Typography>
                      {/* <DarkButton // variant="outlined"
                        // size="large"
                        // color="default"
                        onClick={() =>
                          history.push(
                            "/update_package/" +
                              (packageId[ID2 ] +
                                "/" +
                                (value == 0 ? "Monthly" : "Yearly")) +
                              "/" +
                              currency
                          )
                        }
                        disabled={
                          expired == false
                            ? currentPackage?.package_id ===
                              packageId[ID2]
                            : false
                        }
                      >
                        {currentPackage?.package_id ===
                        packageId[ID2]
                          ? "Renew"
                          : "Purchase"}
                      </DarkButton> */}

<Button variant="contained" type="submit" className="addBtn" component="span" disabled={currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) && daysTillPackageExpires(currentPackage?.expiry_date) > 10} 
                      onClick={() => handleRedirect( ("/update_package/" +
                      (packageId[ID2] +
                        "/" +
                        (value == 0 ? "Monthly" : "Yearly")) +
                      "/" +
                      currency), (currentPackage?.package_id ===
                        packageId[ID2] &&
                      ((Months < 12 && value == 0) ||
                        (Months >= 12 && value == 1))
                        ? true
                        : false), currentPackage?.expiry_date)}
                    >
                        {currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? t("Renew") : t("Purchase")}
                      </Button>



                        {/* <Button variant="contained" type="submit" className="addBtn" component="span" disabled={currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) && daysTillPackageExpires(currentPackage?.expiry_date) > 10} 
                      onClick={() => handleRedirect( ("/update_package/" +
                      (packageId[ID2] +
                        "/" +
                        (value == 0 ? "Monthly" : "Yearly")) +
                      "/" +
                      currency), (currentPackage?.package_id ===
                        packageId[ID2] &&
                      ((Months < 12 && value == 0) ||
                        (Months >= 12 && value == 1))
                        ? true
                        : false), currentPackage?.expiry_date)}
                    >
                        {currentPackage?.package_id === packageId[ID2] && ((Months < 12 && value == 0) || (Months >= 12 && value == 1)) ? t("Renew") : t("Purchase")}
                      </Button> */}




                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <br />

              <p style={{ marginTop: 20, fontSize: 12, fontWeight: "normal", display: "inline", color: "grey" }}>
                {t("*Free plan allows to sign up a single user and it will be valid for 15 days after registration. It is ideal for anyone who wants to explore this application and become familiar with it. To unlock the specialized and professional features, simply upgrade your package to Small/Medium or Enterprise plan and get full access.")}
              </p>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
        </div>
        <br />
        <br />
        <br />
      </div>;
  }
}
